module.exports = __webpack_public_path__ + "static/mezzoloth-cc5c3eb7d52805c00dce254b0bd565db.png";